export default __webpack_public_path__ + "static/media/Step-4_5-safari.49f6d032.mov";